import React, { useState, useEffect } from "react";
// import { isMobile } from "mobile-device-detect";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";
import Srcset from "./Srcset";
import styles from "../common/common.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { reportError } from "@/helpers/errorHelper";
import { getBaseColor } from "@/helpers/generalHelper";

const Swatches = ({
  data,
  selected, // optional prop (set selected swatch from parent component)
  setSelected, // optional prop (if selected swatch data needs to be passed to parent)
  stickyProductBox,
  isStickySwatchesOpen,
  showStickySwatches,
  ArrowDown,
  slidesPerView,
  type,
  hexCodeArray, // Only for color picker swatches
  variantsData,
  showLastOne,
  fastShippingColors,
  category,
  colorMapping,
  highlightColor,
  onlyPDPColor,
  soldOutOptions = [],
  linkedProductsArray = [],
  categoryLvl1 = ''
}) => {
  const [active, setActive] = useState(false);

  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();
  const isMobile = useMediaQuery("(max-width: 767px)");
  React.useEffect(() => {
    if (swiper && swiper.params?.navigation) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation?.init();
      swiper.navigation?.update();

      swiper.slides.forEach((slide) => {
        if(!isMobile) {
          try {
            slide.setAttribute('tabindex', '-1');
            const label = slide.querySelector('label'); // Find the label inside the slide
            if (slide.classList.contains('swiper-slide-duplicate')) {
              if (label) {
                label.setAttribute('tabindex', '-1'); // Set tabindex -1 for label in duplicate slides
              }
            } else {
              if (label) {
                label.setAttribute('tabindex', '0'); // Set tabindex 0 for label in other slides
              }
            }
          } catch (error) {
            reportError("error on swatch tab indexing");
            reportError(error); // Log the error for debugging
          }
        }
      });
    }
  }, [swiper]);

  useEffect(() => {
    if (selected && (!onlyPDPColor || highlightColor)) setActive(selected);
  }, [selected,highlightColor]);

 

  const dataLength = (typeof data != "undefined" && data) ? data.length : 0;
  const slidesPerViewMobile = stickyProductBox ? 6 : 8;
  const slidesPerViewDesktop = stickyProductBox ? 8 : 10;
  var loop = false;
  if (isMobile) {
    loop = dataLength > slidesPerViewMobile ? true : false;
  } else {
    loop = dataLength > slidesPerViewDesktop ? true : false;
  }
  const breakpoints = {
    320: {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
    },
    768: {
      slidesPerView: slidesPerViewDesktop,
      slidesPerGroup: slidesPerViewDesktop,
    },
    1024: {
      slidesPerView: slidesPerViewDesktop,
      slidesPerGroup: slidesPerViewDesktop,
    },
  };

  const swatchRowClass =
    (isMobile && typeof data != "undefined" && data && slidesPerViewMobile >= data.length) ||
    (!isMobile && typeof data != "undefined" && data &&  slidesPerViewDesktop >= data.length)
      ? "no-padding"
      : 0;

  const isValidUrl = (_string) => {
    const matchPattern =
      /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return matchPattern.test(_string);
  };

  const selectHandler = (e) => {
    if (setSelected) setSelected(e.target.value);
    setActive(e.target.value);
  };

  // Function to check if the variant is fast shipping
  const showFastShippingBadge = (key) => {
    //check only for color swatches
    if (type == "color") {
      //if there is only one color swatch, then don't show the fast shipping badge
      if(data?.length > 1) {
        //check if the current swatch is fast shipping
        if (fastShippingColors?.length > 0 && fastShippingColors.includes(hexCodeArray[key][0])) {
          return true
        }
      }
    }
    return false;
  };

  const Swatch = (ele, key, isSticky, isLastOne) => {
    let isSoldOut = false;
    if (soldOutOptions && soldOutOptions.length > 0) {
      isSoldOut = soldOutOptions.includes(ele);
    } else if (variantsData && variantsData[key] && typeof variantsData[key].quantity !== "undefined") {
      isSoldOut = variantsData[key]?.quantity === 0;
    }
    return (
      <>
        <div key={key} className={`swatches-item`} data-gaTrack={`${(linkedProductsArray?.length >= 1)? 'ga-pdp-linked-impression' : ''}`} data-gatracklink={`${(linkedProductsArray?.length >= 1)? categoryLvl1 + ' - color swatch view' : ''}`}>
          {showFastShippingBadge(key) && <span className={`fast_shipping_dot ${styles.fast_shipping_badge}`}></span>}
          <input
          tabIndex={-1}
            type="radio"
            id={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
            name={`color-swateche-${isSticky ? "sticky" : ""}`}
            value={ele}
            onChange={(e) => selectHandler(e)}
            aria-label={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
            className={`${isSoldOut ? "ga-soldout-clicked" : ""}`} 
          />
          <label tabIndex={0}
            className={ele === active ? "active" : ""}
            htmlFor={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
          >
            {isValidUrl(ele) ? (
              <Srcset className="swatches-type" src={ele} />
            ) : type == "color" && hexCodeArray[key] ? (
              hexCodeArray[key].length === 1 ? (
                <div
                  className={`swatches-type ${styles.main}`}
                  style={{ backgroundColor: `#${hexCodeArray[key][0]}` }}
                ></div>
              ) : (
                <div className={styles.main}>
                  {hexCodeArray[key].map((hexCode, index) => {
                    return (
                      <div
                        className="swatches-type"
                        key={index}
                        style={{ backgroundColor: `#${hexCode}` }}
                      ></div>
                    );
                  })}
                </div>
              )
            ) : (
              ele
            )}
          </label>
          {showLastOne && isLastOne && data?.length > 1 && <div className="last-one">1 left</div>}
        </div>
      </>
    );
  };

  const LinkedSwatch = (ele,key,isSticky) => {
    return (
      <>

        <div className="swatches-item"
        key={key}>
          <input
          tabIndex={-1}
            type="radio"
            id={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
            name={`color-swateche-${isSticky ? "sticky" : ""}`}
            value={ele.baseColor}
            onChange={() => {window.location.href=`${process.env.NETLIFY_URL}${ele.link}`}}
            aria-label={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
            className={`ga-linkedproduct-clicked`} 
            ga4data={`${categoryLvl1} - color swatch click`}
          />
          
          <label tabIndex={0}
            className={ele.baseColor === active ? "active" : ""}
            htmlFor={`color-swateche-${isSticky ? "sticky" : ""}${key}`}
            
          >
          <div
              className={`swatches-type ${styles.main}`}
              style={{ backgroundColor: `#${ele.hexColor}` }}
            ></div>
          </label>
        </div>
      </>
    );
  };
  const [swatchesVisibility, setSwatchesVisibility] = useState(false);
  const toggleSwatches = () => {
    setSwatchesVisibility(!swatchesVisibility);
  };

  useEffect(() => {
    if (typeof isStickySwatchesOpen != "undefined") {
      isStickySwatchesOpen(swatchesVisibility);
    }
  });

  //checks for variant quanity and value 
  const isLastOne = (key, variantsData) => {
    if ((variantsData[key]?.type === "Color" && //if type color
      variantsData[key].key === hexCodeArray[key][0] && //if current index value matches value from variants object
      variantsData[key].quantity === 1) //if variant has only one quantity
      ||
      (variantsData[key]?.type === "Style" && //if type style (for letters)
        variantsData[key].quantity === 1) //if variant has only one quantity
    ) {
      return true;
    }
    return false;
  }

  return (
    <div>
      <div
        className={`swatches-title small ${
          typeof showStickySwatches != "undefined" && !showStickySwatches
            ? "d-none"
            : ""
        } ${stickyProductBox && swatchesVisibility ? "open" : ""} ${
          stickyProductBox && typeof data != "undefined" &&  data && data.length > 1 ? "" : "swatches-disabled"
        }`}
        onClick={toggleSwatches}
      >
        {type == "color" ? (
            <span className="name">
            <span>Color:</span> 
            <span>
              {/* Show basecolor value on non jewelry & non beauty PDP, and variant option color of otherwise. 
              Defaults to variant option if basecolor is not present */}
              {!category && getBaseColor(colorMapping.find((color) => color?.variantColor === active)?.baseColor)
                ? getBaseColor(colorMapping.find((color) => color?.variantColor === active)?.baseColor)
                : active}
            </span>
          </span>
        ) : (
          <span className="name">
            Personalization:
            {active}
          </span>
        )}
        {stickyProductBox && typeof data != "undefined" &&  data && data.length > 1 && (
          <Srcset
            requirePath={true}
            svgFile={true}
            height="15"
            width="15"
            src={ArrowDown}
          />
        )}
      </div>
      <div
        className={`swatches-row ${swatchRowClass} ${
          stickyProductBox && swatchesVisibility ? "d-block" : ""
        }`}
      >
        <Swiper
          slidesPerView={10}
          slidesPerGroup={10}
          spaceBetween={10}
          navigation={{
            prevEl: prevRef?.current,
            nextEl: nextRef?.current,
          }}
          onSwiper={setSwiper}
          modules={[Pagination, Navigation]}
          breakpoints={breakpoints}
          loop={loop}
          className="swatches-swiper"
          touchStartPreventDefault={false}
        >
          {/* Display color swatch for more then 1 color on non beauty & non jewelry products */}
          {/* Display color swatch if only 1 color is there but if it has linked products */}
          {data&& ((data?.length>1 || linkedProductsArray?.length >= 1) || category) && data.map((ele, i) => (
            <SwiperSlide key={`${stickyProductBox ? "sticky" : null}${i}`}>
              {Swatch(ele, `${i}`, stickyProductBox , isLastOne(i,variantsData))}
            </SwiperSlide>
          ))}
          {data&& ((data?.length>1 || linkedProductsArray?.length >= 1)) && linkedProductsArray?.map((ele, i) => (
            <SwiperSlide key={`${stickyProductBox ? "sticky" : null}${i}`}>
              {LinkedSwatch(ele, `linked-${i}`, stickyProductBox)}
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swatches-arrow">
          <div className="swiper-button btn-prev" ref={prevRef}>
            <Srcset
              requirePath={true}
              svgFile={true}
              height="15"
              width="15"
              src={ArrowDown}
            />
          </div>
          <div className="swiper-button btn-next" ref={nextRef}>
            <Srcset
              requirePath={true}
              svgFile={true}
              height="15"
              width="15"
              src={ArrowDown}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Swatches;
